import { useMemo } from "react";
import { useSelector } from "react-redux";

export const usePermission = (moduleName) => {
    // Select permissions array from state.user.permissions
    const permissions = useSelector((state) => state.user?.permissions || []);

    return useMemo(() => {
        if (!moduleName) {
            return {
                canCreate: false,
                canView: false,
                canEdit: false,
                canDelete: false,
                canExecute: false,
                hasPermission: () => false
            };
        }

        // Helper to check for exact permission string like 'agencyInfo.create'
        const hasPermission = (action) => {
            return permissions.includes(`${moduleName}.${action}`);
        };

        const canCreate = hasPermission("create");
        const canEdit = hasPermission("edit");
        const canDelete = hasPermission("delete");

        // Executing requires both create and delete access
        const canExecute = canCreate && canDelete;

        // Viewing is allowed if explicitly granted or if user has create, edit, or delete access
        const canView =
            hasPermission("view") || canCreate || canEdit || canDelete;

        return {
            canCreate,
            canView,
            canEdit,
            canDelete,
            canExecute,
            hasPermission
        };
    }, [permissions, moduleName]);
};
